import React from "react";
import Hero from "../components/Hero";
import ServiceGrid from "../components/ServiceGrid";
import { industries, serviceAreas } from "../data/siteContent";

export default function Home() {
  return (
    <>
      <Hero />
      <ServiceGrid />
      <section className="process-band">
        <div>
          <p className="eyebrow">How Work Flows</p>
          <h2>From arrival notice to clean dock handoff.</h2>
        </div>
        <ol className="process-list">
          <li><strong>Plan</strong><span>Confirm container type, freight profile, timing, dock rules, and crew size.</span></li>
          <li><strong>Unload</strong><span>Destuff, sort, count support, inspect visible exceptions, and protect product flow.</span></li>
          <li><strong>Stage</strong><span>Palletize, wrap, label, rework, or cross-dock freight for the next team.</span></li>
        </ol>
      </section>
      <section className="split-section">
        <div>
          <p className="eyebrow">Who We Support</p>
          <h2>Built for operations teams that need reliable hands on the dock.</h2>
          <div className="pill-list">{industries.map((item) => <span key={item}>{item}</span>)}</div>
        </div>
        <div>
          <p className="eyebrow">Service Area</p>
          <h2>Fairview CM supports warehouses across the GTA and Southern Ontario.</h2>
          <div className="area-list">{serviceAreas.map((area) => <span key={area}>{area}</span>)}</div>
        </div>
      </section>
    </>
  );
}
